import { Alert, Form, Input, Row } from "antd"
import { useSelector } from "react-redux";
import { serviceLoading } from "src/common/apiLoader/state/selection";
import { SystemDescriptions } from "src/common/descriptions";
import { getInputRequiredRule } from "src/common/util";
import { Col24 } from "src/components/Columns";
import { FormActionButtons } from "src/components/FormActionButtons";
import { CREATE_CONTRACT_PAYMENT_API } from "src/features/CustomerPayment/state/actionTypes";
import { RootState } from "src/state/reducer";

interface Props {
    onFinish: (deleReason: string) => void
    onCancel: () => void
}

export interface ReduxProps {
    error?: any
    isDeletingContractDebit: boolean
}

export const DeleteContractDebitForm = (props: Props) => {

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        error: state.serviceContract.error,
        isDeletingContractDebit: serviceLoading(state, [CREATE_CONTRACT_PAYMENT_API]),
    }))

    const descriptions = SystemDescriptions.PAGES.PAYABLE_CONTRACT.DELTE_CONTRACT_DEBIT_RECORD
    const commonDescriptions = SystemDescriptions.PAGES.COMMON

    const [form] = Form.useForm();

    const onFinish = (formValues: any) => {
        props.onFinish(formValues.comment)
    }

    const getButtonStatus = (): boolean => {
        return !form.isFieldsTouched(true) ||
            form.getFieldsError().filter(({ errors }) => errors.length)
                .length > 0
    }

    const handleCancelClick = () => {
        props.onCancel()
    }

    const renderButtons = () => (
        <FormActionButtons
            cancelText={descriptions.CANCEL_BUTTON}
            actionText={descriptions.SAVE_BUTTON}
            actionDisabled={getButtonStatus}
            onCancel={handleCancelClick}
            actionLoading={reduxProps.isDeletingContractDebit}
        />
    )

    const renderForm = () => (
        <Form
            form={form}
            layout="vertical"
            requiredMark={false}
            autoComplete={'none'}
            onFinish={onFinish}
        >
            <Row gutter={[16, 8]}>
                <Col24>
                    <Form.Item
                        label={descriptions.FORM.COMMENT.LABEL}
                        name={"comment"}
                        validateTrigger="onBlur"
                        rules={[
                            getInputRequiredRule(descriptions.FORM.COMMENT.LABEL),
                        ]}
                    >
                        <Input
                            placeholder={descriptions.FORM.COMMENT.PLACEHOLDER}
                        />
                    </Form.Item>
                </Col24>
            </Row>
            {
                reduxProps.error &&
                <Alert
                    message={"ERROR"}
                    showIcon
                    description={reduxProps.error?.detail.message ?? commonDescriptions.FORM.UNKNOWN_ERROR}
                    type="error"
                    style={{
                        marginBottom: 12,
                    }}
                />
            }
            {renderButtons()}
        </Form >
    )

    return (
        renderForm()
    )
}
